import React, { useState } from "react";

function QuizOption({
  no,
  text,
  isCorrect = null,
  isSelected,
  onClick,
}: {
  no: number;
  text: string;
  isCorrect?: boolean | null;
  isSelected?: boolean;
  onClick?: () => void;
}) {
  return (
    <div
      className={`flex items-center justify-between rounded-full border-[2px] ${
        isSelected && "border-b2b-primary"
      } ${isCorrect === true && "border-[#0CD769]"} ${
        isCorrect === false && "border-[#FF5153]"
      } cursor-pointer bg-[#D9D9D9] px-5 py-3 text-[15px]`}
      onClick={onClick}
    >
      <div>{text}</div>
      <div className="flex h-[36px] w-[36px] items-center justify-center rounded-lg bg-white p-2 font-medium">
        {no}
      </div>
    </div>
  );
}

export default QuizOption;
